<section class="productDetailsSection">
  <header>
    <h3>{{title}}</h3>
  </header>
  <ng-container [ngSwitch]="type">
    <ng-container *ngSwitchCase="productType.SUNGLASSES">
      <dl class="productDetailsSection__technical">
        <dt><i>{{'productDetails.technical.gender.title' | translate}}</i></dt>
          <dd><i>{{technical.frameGender}}</i></dd>
        <dt><i>{{'productDetails.technical.material.title' | translate}}</i></dt>
          <dd><i>{{technical.frameMaterial}}</i></dd>
        <dt><i>{{'productDetails.technical.frameColour.title' | translate}}</i></dt>
          <dd><i>{{technical.frameColour}}</i></dd>
        <dt><i>{{'productDetails.technical.shape.title' | translate}}</i></dt>
          <dd><i>{{technical.frameShape}}</i></dd>
        <dt><i>{{'productDetails.technical.lensColour.title' | translate}}</i></dt>
          <dd><i>{{technical.lensColour}}</i></dd>
        <dt><i>{{'productDetails.technical.polarization.title' | translate}}</i></dt>
          <dd><i>{{isAvailable(technical.polarization) | translate}}</i></dd>
        <dt><i>{{'productDetails.technical.mirrored.title' | translate}}</i></dt>
          <dd><i>{{isAvailable(technical.mirrored) | translate}}</i></dd>
        <dt><i>{{'productDetails.technical.uvfilter.title' | translate}}</i></dt>
          <dd><i>{{technical.filterUV}}</i></dd>
        <dt><i>{{'productDetails.technical.gradialColoring.title' | translate}}</i></dt>
          <dd><i>{{isAvailable(technical.gradialColoring) | translate}}</i></dd>
        <dt><i>{{'productDetails.technical.antireflex.title' | translate}}</i></dt>
          <dd><i>{{isAvailable(technical.antiReflex) | translate}}</i></dd>
        <dt><i>{{'productDetails.technical.elasticHinge.title' | translate}}</i></dt>
          <dd><i>{{isAvailable(technical.elasticHinge) | translate}}</i></dd>
        <dt><i>{{'productDetails.technical.correctionAvailable.title' | translate}}</i></dt>
          <dd><i>{{isAvailable(technical.correctionAvailable) | translate}}</i></dd>
      </dl>
    </ng-container>
    <ng-container *ngSwitchCase="productType.FRAMES">
      <dl class="productDetailsSection__technical">
        <dt><i>{{'productDetails.technical.gender.title' | translate}}</i></dt>
          <dd><i>{{technical.frameGender}}</i></dd>
        <dt><i>{{'productDetails.technical.material.title' | translate}}</i></dt>
          <dd><i>{{technical.frameMaterial}}</i></dd>
        <dt><i>{{'productDetails.technical.frameColour.title' | translate}}</i></dt>
          <dd><i>{{technical.frameColour}}</i></dd>
        <dt><i>{{'productDetails.technical.shape.title' | translate}}</i></dt>
          <dd><i>{{technical.frameShape}}</i></dd>
        <dt><i>{{'productDetails.technical.frameMounting.title' | translate}}</i></dt>
          <dd><i>{{technical.frameMounting}}</i></dd>
        <dt><i>{{'productDetails.technical.elasticHinge.title' | translate}}</i></dt>
          <dd><i>{{isAvailable(technical.elasticHinge) | translate}}</i></dd>
        <dt><i>{{'productDetails.technical.progressiveLenses.title' | translate}}</i></dt>
          <dd><i>{{isAvailable(technical.progressiveLenses) | translate}}</i></dd>
        <dt><i>{{'productDetails.technical.frameColour.title' | translate}}</i></dt>
          <dd><i>{{technical.frameColour}}</i></dd>
      </dl>
    </ng-container>
    <ng-container *ngSwitchCase="productType.CONTACT_LENS">
      <dl class="productDetailsSection__technical">
        <dt><i><i>{{'productDetails.technical.replacementType.title'| translate}}</i></i></dt>
          <dd><i>{{technical.replacementType}}</i></dd>
        <dt><i><i>{{'productDetails.technical.materialType.title' | translate}}</i></i></dt>
          <dd><i>{{technical.material}}</i></dd>
        <dt><i>{{'productDetails.technical.uvfilter.title' | translate}}</i></dt>
        <dd><i>{{isAvailable(technical.filterUV) | translate}}</i></dd>
        <dt><i>{{'productDetails.technical.airPermeability.title'| translate}}</i></dt>
          <dd><i>{{technical.airPermeability}}</i></dd>
        <dt><i>{{'productDetails.technical.moisture.title'| translate}}</i></dt>
          <dd><i>{{technical.moisture}}</i></dd>
        <dt><i>{{'productDetails.technical.type.title'| translate}}</i></dt>
          <dd><i>{{technical.type}}</i></dd>
      </dl>
    </ng-container>
  </ng-container>
  <p *ngIf="technical.filterUVCode">
    <strong>{{'productDetails.technical.uvfilter.type' | translate}}: {{technical.filterUV.slice(4)}}</strong>
    {{'productDetails.technical.uvfilter.'+technical.filterUVCode | translate}}
  </p>
  <p *ngIf="technical.polarization">
    {{'productDetails.technical.polarization.description' | translate}}
  </p>
</section>
